import {request} from "./requests";
import {Entity} from "./converter";
import {Comment} from "./converter";
import {errorMessage} from "../utils";

/**
 * You should first load the comments from cache, then load the comments from there.
 * @param shortcode
 * @return {Promise<Array>}
 */
export async function getMainComments(shortcode) {
    let comments = await request({
        url: `/cmt/m/${shortcode}`,
        method: 'get'
    });
    comments = Comment.convertComments(comments)
    this.$store.commit('cacheComments', {shortcode: shortcode, comments: comments});
    return comments;
}

/**
 * get all childs for the root thread.
 * @param {String} firstLevelId, the root thread id
 * @return {Promise<void>}
 */
export async function getRootChildComments(firstLevelId){
    let threads = await request({
        url: `/cmt/c/r/${firstLevelId}`,
        method: 'get'
    })
    threads = Comment.convertComments(threads)
    console.log('get root child comments:', threads);
    return threads;
}


/**
 *
 * @param {String} shortcode
 * @param {String} username
 * @param {String} text
 * @param {String} parentId, if submit new root comment, parentId is null
 * @param {String} firstLevelId, if submit new root comment, firstLevelId is null.
 */
export async function saveComment(shortcode, text, parentId=null, firstLevelId=null){
    // thread could be main thread / child thread.
    let r = await request({
        url: `/cmt/s`,
        data: {
            shortcode: shortcode,
            content: text,
            parentId: parentId,
            firstLevelId: firstLevelId
        },
        method: 'post'
    });
    if(r.pass){
        let thread = r.data;
        return Comment.convertComment(thread);
    }else{
        throw new Error(r.error);
    }
}

/**
 * likes/dislikes the thread.
 * @param {String} threadId
 * @param {Boolean} isLikes
 * @return {Promise<void>}
 */
export async function likes(threadId, isLikes){
    try{
        await request({
            url: `/cmt/likes`,
            data: {
                threadId: threadId,
                isLikes: isLikes
            },
            method: 'post'
        });
    }catch(err){
        console.log('likes error:', err);
        throw err;
    }
}

export async function getHisComments(pageNum){
    let threads = await request({
        url: `/cmt/h/c/${pageNum}`
    })
    return threads;
}

export async function getHisCommentLikes(pageNum){
    let threads = await request({
        url: `/cmt/h/l/${pageNum}`
    })
    return threads;
}



// WEBPACK FOOTER //
// ./src/data/comment.js